// Client for the site-architecture map (/api/content/architecture on APA.ADMIN.API): the whole
// site as a nested page tree, each leaf classified static vs dynamic-template with record counts.
//
// Goes through the shared `axios` instance (NOT raw fetch) so the Auth0AxiosBridge request
// interceptor attaches the admin Bearer token (raw fetch is invisible to it and 401s when
// BYPASS_AUTH is off).
import axios from "axios";

export interface ArchitectureNode {
	kind: "folder" | "page" | "dynamic" | string;
	name: string;
	path: string;
	id?: string | null;
	title?: string | null;
	contentTypeKey?: string | null;
	contentTypeLabel?: string | null;
	recordCount?: number | null;
	children: ArchitectureNode[];
}

export interface ArchitectureResponse {
	language: string;
	totalPages: number;
	staticPages: number;
	dynamicTemplates: number;
	totalDynamicRecords: number;
	roots: ArchitectureNode[];
}

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export async function getSiteArchitecture(language = "fr"): Promise<ArchitectureResponse> {
	const r = await axios.get<ArchitectureResponse>(`${apiBase}/api/content/architecture`, {
		params: { language },
		withCredentials: true
	});
	return r.data;
}
